<script setup lang="ts">
import Heading from "@/components/Heading.vue"
import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"

type Section = "details" | "address" | "applications"

defineProps<{
  partnerId: number
  partnerName: string
  organizationName: string
  activeSection: Section
}>()

const emit = defineEmits<{
  (e: "update:activeSection", section: Section): void
}>()

const navItems: { title: string; value: Section }[] = [
  { title: "Details", value: "details" },
  { title: "Address", value: "address" },
  { title: "Applications", value: "applications" },
]
</script>

<template>
  <div class="px-4 py-6">
    <Heading
      :title="partnerName"
      :description="`Partner at ${organizationName}`"
    />

    <div class="flex flex-col lg:flex-row lg:space-x-12">
      <aside class="w-full max-w-xl lg:w-48">
        <nav class="flex flex-col space-y-1 space-x-0">
          <Button
            v-for="item in navItems"
            :key="item.value"
            variant="ghost"
            :class="[
              'w-full justify-start',
              { 'bg-muted': activeSection === item.value },
            ]"
            @click="emit('update:activeSection', item.value)"
          >
            {{ item.title }}
          </Button>
        </nav>
      </aside>

      <Separator class="my-6 lg:hidden" />

      <div :class="['flex-1', activeSection !== 'applications' && 'md:max-w-2xl']">
        <section :class="[activeSection !== 'applications' && 'max-w-xl', 'space-y-12']">
          <slot />
        </section>
      </div>
    </div>
  </div>
</template>
